// extracted by mini-css-extract-plugin
module.exports = {"container":"ManualPay_container__2jRTt","label":"ManualPay_label__2VjSp","handle":"ManualPay_handle__33w92","reason":"ManualPay_reason__rZllO","content":"ManualPay_content__3y16f"};